<template>
    <div>
        <div v-if="active == 0">
            <van-list v-model="listLoading1" :finished="listFinished1" @load="get_rhd_result" finished-text="没有更多了">
                <div v-for="(item, index) in listData1" :key="index">
                    <el-divider>试验编号：{{ item.shiYanBianHao }}</el-divider>
                    <van-cell-group inset>
                        <van-cell title="试验时间" :value="item.shiYanShiJian" />
                        <van-cell title="小球1温度" :value="item.wenDu1 + '℃'" />
                        <van-cell title="小球1时间" :value="item.time1" />
                        <van-cell title="小球2温度" :value="item.wenDu2 + '℃'" />
                        <van-cell title="小球2时间" :value="item.time2" />
                    </van-cell-group>
                </div>
            </van-list>
        </div>
        <div v-if="active == 1">
            <van-list v-model="listLoading" :finished="listFinished" @load="get_rhd_result_log" finished-text="没有更多了">
                <div v-for="(item, index) in listData" :key="index">
                    <el-divider>{{ item.createTime }}</el-divider>
                    <van-collapse v-model="activeNames">
                        <van-collapse-item title="发送">{{ item.sendData }}</van-collapse-item>
                        <van-collapse-item title="接收">{{ item.receiveData }}</van-collapse-item>
                    </van-collapse>
                </div>
            </van-list>
        </div>
        <div v-else-if="active == 2">
            <van-cell-group title="上传公司名称">
                <van-cell title="上传公司名称" is-link @click="show_company_name = true" :value="base_device.jieKouCompanyName"></van-cell>
            </van-cell-group>
            <div v-if="base_device.jieKouCompanyName == '智诚新研'">
                <van-cell-group title="上传配置">
                    <van-field clearable center label="采集代码" v-model="zcxy.caijidaima">
                        <template #button>
                            <van-button size="small" type="primary" @click="zcxy_get_yangpinbianhao">获取样品编号</van-button>
                        </template>
                    </van-field>
                    <van-cell title="样品编号" is-link @click="zcxy.show_ymbh = true" :value="zcxy.yangpinbianhao"></van-cell>
                </van-cell-group>
                <van-button block type="info" style="margin-top: 20px;" @click="zcxy_save_config">保存配置</van-button>
                <van-popup v-model="zcxy.show_ymbh" position="bottom">
                    <van-picker title="请选择样品编号" show-toolbar :columns="zcxy.arr_yangpinbianhao" value-key="samplenum" @confirm="zcxy_yangpinbianhao_confirm" @cancel="zcxy.show_ymbh = false"></van-picker>
                </van-popup>
            </div>
        </div>
        <van-tabbar v-model="active" @change="handleChange">
            <van-tabbar-item icon="search">查询</van-tabbar-item>
            <van-tabbar-item icon="todo-list-o">日志</van-tabbar-item>
            <van-tabbar-item icon="setting-o">设置</van-tabbar-item>
        </van-tabbar>
        <van-popup v-model="show_company_name" position="bottom">
            <van-picker title="请选择公司名称" show-toolbar :columns="columns" value-key="dataValue" @confirm="saveCompanyName" @cancel="show_company_name = false"></van-picker>
        </van-popup>



    </div>
</template>

<script>
import Vue from "vue";
import Vant from "vant";

Vue.use(Vant);
export default {
    props: ["serialNumber"],
    data() {
        return {
            activeNames: [1],
            pageSize: 10,
            currentPage: 1,
            listLoading: false,
            listFinished: false,
            listData: [],
            pageSize1: 10,
            currentPage1: 1,
            listLoading1: false,
            listFinished1: false,
            listData1: [],
            show_company_name: false,
            zcxy: {
                show_ymbh: false,
                caijidaima: "20230323",
                yangpinbianhao: "",
                arr_yangpinbianhao: [],
            },
            active: 2,
            columns: [],
            base_device: { jieKouCompanyName: "" },
        };
    },
    methods: {
        get_rhd_result() {
            let that = this;
            that.axios
                .post("RHD_Result/GetList", {
                    serialNumber: that.serialNumber,
                    pageSize: that.pageSize1,
                    currentPage: that.currentPage1,
                })
                .then(function (response) {
                    response.data.data.data.forEach((element) => {
                        that.listData1.push(element);
                    });
                    that.listLoading1 = false;
                    if (that.listData1.length >= response.data.data.total) {
                        that.listFinished1 = true;
                    } else {
                        that.currentPage1++;
                    }
                });
        },
        get_rhd_result_log() {
            let that = this;
            that.axios
                .post("RHD_Result_Log/GetList", {
                    serialNumber: that.serialNumber,
                    pageSize: that.pageSize,
                    currentPage: that.currentPage,
                })
                .then(function (response) {
                    response.data.data.data.forEach((element) => {
                        that.listData.push(element);
                    });
                    that.listLoading = false;
                    if (that.listData.length >= response.data.data.total) {
                        that.listFinished = true;
                    } else {
                        that.currentPage++;
                    }
                });
        },
        load_config() {
            let that = this;
            that.loading = this.$loading({
                lock: true,
                text: "加载中",
                spinner: "el-icon-loading",
            });
            that.axios.post("Base_DeviceConfig/Get_Config", {
                serialNumber: that.serialNumber,
                configType: that.base_device.jieKouCompanyName,
            }).then(function (response) {
                let arr = response.data.data;
                if (that.base_device.jieKouCompanyName == '智诚新研') {
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i].configName == "采集代码") {
                            that.zcxy.caijidaima = arr[i].configValue;
                        }
                        else if (arr[i].configName == "样品编号") {
                            that.zcxy.yangpinbianhao = arr[i].configValue;
                        }
                    }
                }

                that.loading.close();
            });
        },
        zcxy_save_config() {
            let that = this;
            that.loading = this.$loading({
                lock: true,
                text: "保存中",
                spinner: "el-icon-loading",
            });
            that.axios.post("Base_DeviceConfig/Save_Config", {
                arrData: [{
                    serialNumber: that.serialNumber,
                    configType: "智诚新研",
                    configName: "采集代码",
                    configValue: that.zcxy.caijidaima
                }, {
                    serialNumber: that.serialNumber,
                    configType: "智诚新研",
                    configName: "样品编号",
                    configValue: that.zcxy.yangpinbianhao
                }]
            })
                .then(function () {
                    that.loading.close();
                    that.$notify({ type: "success", message: "保存成功" });
                });

        },
        zcxy_get_yangpinbianhao() {
            let that = this;
            that.loading = this.$loading({
                lock: true,
                text: "加载中",
                spinner: "el-icon-loading",
            });
            that.axios.post("RHD200/ZCXY_Get_YangPingBianHao", { onlyText: that.zcxy.caijidaima }).then(function (response) {
                that.zcxy.arr_yangpinbianhao = JSON.parse(response.data.data);
                that.loading.close();
                if (that.zcxy.arr_yangpinbianhao.length == 0) {
                    that.$notify({ type: "danger", message: "未获取到样品编号" });
                }
                else {
                    that.$notify({ type: "success", message: "获取成功" });
                }
            });
        },
        zcxy_yangpinbianhao_confirm(v) {
            let that = this;
            that.zcxy.yangpinbianhao = v.samplenum;
            that.zcxy.show_ymbh = false;
        },
        saveCompanyName(v) {
            let that = this;
            that.base_device.jieKouCompanyName = v.dataValue;
            that.axios.post("Base_Device/UpdateModel", that.base_device).then(function () {
                that.show_company_name = false;
                that.load_config();
            });
        },

        handleChange() {
            let that = this;
            that.loading = this.$loading({
                lock: true,
                text: "加载中",
                spinner: "el-icon-loading",
            });
            setTimeout(() => {
                that.loading.close();
            }, 200);
        },
        loadShangChuanCompanyName() {
            let that = this;
            that.axios.post("Base_SystemBaseData/GetListByDataType", { dataType: "上传公司名称" }).then((res) => {
                that.columns = res.data.data;

            });

        },
        get_base_device() {
            let that = this;
            that.axios
                .post("Base_Device/GetModelBySerialNumber", {
                    serialNumber: that.serialNumber,
                })
                .then(function (response) {
                    that.base_device = response.data.data;
                    that.load_config();
                });
        }

    },
    mounted() {
        let that = this;
        that.loadShangChuanCompanyName();
        that.get_base_device();
        document.title = that.serialNumber;

    }
};
</script>

<style scoped></style>